// Import controller interfaces
import {
    IClaimsController
} from '../Interfaces/ControllerInterfacesBarrel';
// Import api models.
import ApiController from './ApiController';
import {
    ErrorMessage,
    PolicyLoss
} from '@app/models/api';

export default class ProductionClaimsController extends ApiController implements IClaimsController {
    private readonly controllerUrl: string = 'v2/claims';

    public constructor() {
        super();
    }

    public async getPolicyLosses(policyId: number): Promise<PolicyLoss[]> {
        let url: string = `${this.controllerUrl}/${policyId}`;

        try {
            let response: Response = await super.makeGetCall(url, undefined, undefined);
            return await response.json();
        }
        catch (error) {
            if (ErrorMessage.isErrorMessage(error)) {
                error.message = `Could not get previous claims for policy # ${policyId}.`;
            }
            throw error;
        }
    }

    public async submitClaim(policyId: number, claim: PolicyLoss): Promise<string> {
        let url: string = `${this.controllerUrl}/${policyId}`;

        try {
            let response: Response = await super.makePostCall(url, claim, undefined, undefined);
            return await response.text();
        }
        catch (error) {
            if (ErrorMessage.isErrorMessage(error)) {
                error.message = `Could not submit claim for policy # ${policyId}.`;
            }
            throw error;
        }
    }

    public async isPolicyAllowedToMakeClaims(policyId: number): Promise<boolean> {
        let url: string = `${this.controllerUrl}/validation/${policyId}`;

        try {
            let response: Response = await super.makeGetCall(url);
            return await response.json();
        }
        catch (error) {
            if (ErrorMessage.isErrorMessage(error)) {
                error.message = `Could not check claims submission eligibility for policy # ${policyId}.`;
            }
            throw error;
        }
    }

    public async getPolicyLossesPublic(policyId: number, zipCode: string): Promise<PolicyLoss[]> {
        let url: string = `${this.controllerUrl}/public/${policyId}/${zipCode}`;

        try {
            let response: Response = await super.makeGetCall(url, undefined, undefined, false);
            return await response.json();
        }
        catch (error) {
            if (ErrorMessage.isErrorMessage(error)) {
                error.message = `Could not get previous claims for policy # ${policyId}.`;
            }
            throw error;
        }
    }

    public async submitClaimPublic(policyId: number, zipCode: string, claim: PolicyLoss): Promise<string> {
        let url: string = `${this.controllerUrl}/public/${policyId}/${zipCode}`;

        try {
            let response: Response = await super.makePostCall(url, claim, undefined, undefined, false);
            return await response.text();
        }
        catch (error) {
            if (ErrorMessage.isErrorMessage(error)) {
                error.message = `Could not submit claim for policy # ${policyId}.`;
            }
            throw error;
        }
    }

    public async isPolicyAllowedToMakeClaimsPublic(policyId: number, zipCode: string): Promise<boolean> {
        let url: string = `${this.controllerUrl}/public/validation/${policyId}/${zipCode}`;

        try {
            let response: Response = await super.makeGetCall(url, undefined, undefined, false);
            return await response.json();
        }
        catch (error) {
            if (ErrorMessage.isErrorMessage(error)) {
                error.message = `Could not check claims submission eligibility for policy # ${policyId}.`;
            }
            throw error;
        }
    }
}